<template>
  <label class="UIInputLabel">
    <slot />
    <slot name="is-required">
      <span v-if="isRequired" class="UIInputLabel__is-required"> *</span>
    </slot>
    <slot name="is-optional">
      <span v-if="isOptional" class="UIInputLabel__is-optional">
        {{ t('optional') }}
      </span>
    </slot>
    <slot name="after-label" />
  </label>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

withDefaults(
  defineProps<{
    isRequired?: boolean
    isOptional?: boolean
  }>(),
  {
    isRequired: false,
  },
)
</script>

<style scoped lang="scss">
.UIInputLabel {
  @include font-size-16px();
  font-weight: 600;
  color: var(--label-color, #{$color-ui-gray-cool-700});
  margin-bottom: 0.25rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  align-items: center;

  .UIInputLabel__is-required {
    display: contents;
    color: $color-ui-accent-main;
    font-size: 0.875rem;
  }

  .UIInputLabel__is-optional {
    color: $color-ui-neutral-main;
    font-size: 0.875rem;
    font-style: italic;
    font-weight: 400;
  }
}
</style>
